export const APP_TOAST_TYPES = {
  SUCCESS: "success",
  ERROR: "error",
};

export const TOP_NAVIGATION_BACKGROUND_TYPES = {
  DEFAULT: "default",
  ERROR: "error",
};
